import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { PreviousManagerEvaluationsModal } from "src/app/manager-evaluation/evaluate-team/previous-manager-evaluations/previous-manager-evaluations.modal";
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { UserCalibrationOverviewModule } from '../calibration/components/user-overview/user-overview.module';
import { AutoSaveModule } from '../shared/components/autosave/autosave.module';
import { Evaluation360ReportModule } from '../shared/components/full-reports/360-evaluation/360-evaluation-report.module';
import { FreeEvaluationReportModule } from '../shared/components/full-reports/free-evaluation/free-evaluation-report.module';
import { QuestionAnswerModule } from '../shared/components/question-answer/question-answer.module';
import { QuestionTypesModule } from '../shared/components/question-types/question-types.module';
import { StepDescriptionModule } from '../shared/components/step-description/step-description.module';
import { AiGeneralSummaryModalModule } from '../shared/modals/ai-general-summary-modal/ai-general-summary-modal.module';
import { UtilService } from '../shared/services/util.service';
import { EvaluateTeamPage } from './evaluate-team/evaluate-team.page';
import { PreviewNineBoxModal } from './evaluate-team/preview-ninebox/preview-ninebox.modal';
import { ManagerEvaluationPage } from './manager-evaluation.page';
import { ManagerEvaluationService } from './manager-evaluation.service';

const routes: Routes = [
    {
        path: "",
        component: ManagerEvaluationPage,
    },
    {
        path: ":userId/:calibration",
        component: EvaluateTeamPage,
    },
    {
        path: ":userId",
        component: EvaluateTeamPage,
    },
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        PipesModule,
        StepDescriptionModule,
        Evaluation360ReportModule,
        QuestionTypesModule,
        QuestionAnswerModule,
        UserCalibrationOverviewModule,
        MatTooltipModule,
        FreeEvaluationReportModule,
        AutoSaveModule,
    ],
    declarations: [
        ManagerEvaluationPage,
        EvaluateTeamPage,
        PreviousManagerEvaluationsModal,
        PreviewNineBoxModal
    ],
    providers: [
        ManagerEvaluationService,
        UtilService,
        AiGeneralSummaryModalModule
    ]
})
export class ManagerEvaluationModule { }
